"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdministrativeArea = void 0;
const package_1 = require("../package");
const Place_1 = require("./Place");
const schema_1 = require("../ontologies/schema");
let AdministrativeArea = class AdministrativeArea extends Place_1.Place {
};
exports.AdministrativeArea = AdministrativeArea;
AdministrativeArea.targetClass = schema_1.schema.AdministrativeArea;
exports.AdministrativeArea = AdministrativeArea = __decorate([
    package_1.linkedShape
], AdministrativeArea);
//# sourceMappingURL=AdministrativeArea.js.map